import { createAPIActionEntity } from "../../actions/actionUtils.js";

export const PROJECT_WIZARD = {
  ...createAPIActionEntity("PROJECT_WIZARD"),
  GET_PROJECT: "PROJECT_WIZARD.GET_PROJECT",
  SET_PROJECT: "PROJECT_WIZARD.SET_PROJECT",
  UPDATE_STEP: "PROJECT_WIZARD.UPDATE_STEP",
  UPDATE_ESTIMATE: "PROJECT_WIZARD.UPDATE_ESTIMATE",
  UPDATE_STEP_AND_ESTIMATE: "PROJECT_WIZARD.UPDATE_STEP_AND_ESTIMATE"
};

export const ESTIMATE_DIMENSIONS = {
  MONTHLY: "monthly",
  WEEKLY: "weekly",
  DAILY: "daily",
  HOURLY: "hourly"
};

export const PANEL_STATES = {
  INACTIVE: "PANEL_STATES.INACTIVE",
  ACTIVE: "PANEL_STATES.ACTIVE",
  SET: "PANEL_STATES.SET",
  OPTIONAL: "PANEL_STATES.OPTIONAL",
  SKIPPED: "PANEL_STATES.SKIPPED"
};

export const PANEL_TYPES = {
  GROUP: "panelGroup",
  DETAILS: "detailsPanel",
  OTP: "otpPanel",
  PROVIDER: "providerPanel",
  REGION: "locationPanel",
  SSH: "SSHAdminPanel",
  CIDR: "CIDRPanel",
  VPN_GATEWAY: "VPNPanel",
  DISPLAY_GATEWAY: "displayGatewayPanel",
  WORKSTATION: "workstationPanel",
  STORAGE: "storagePanel",
  RENDER_MANAGER: "renderManagerPanel",
  NODE: "nodePanel",
  SNOWFLAKE: "snowflakePanel",
  SUMMARY: "summary",
  ESTIMATE: "estimate"
};
